<div class="row">
  <div *ngIf="!children" class="col-12 col-sm-6 pb-4">
    <h2>Children list is empty!</h2>
  </div>
  <div class="col-12 col-sm-6 pb-4" *ngFor="let child of children">
    <app-link-button [truncate]="truncateLinkButton(child)" [title]="titleLinkButton(child)" [icon]="faPen" (click)="listItemClicked(child)"></app-link-button>
  </div>
</div>
